import { render, staticRenderFns } from "./EditLink.vue?vue&type=template&id=d9550ed8&scoped=true&"
import script from "./EditLink.vue?vue&type=script&lang=ts&"
export * from "./EditLink.vue?vue&type=script&lang=ts&"
import style0 from "./EditLink.vue?vue&type=style&index=0&id=d9550ed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9550ed8",
  null
  
)

export default component.exports